import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Parametros() {
  const [tipos, setTipos] = useState([]);
  const [tipoSelecionado, setTipoSelecionado] = useState('tema_documento');
  const [linhas, setLinhas] = useState([]);
  const [original, setOriginal] = useState([]);
  const [alterado, setAlterado] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const colunasPorTipo = {
    'status_atividade': ['descricao', 'valor'],
    'tema_documento': ['valor'],
    'default': ['valor'],
  };

  const labelColunas = {
    valor: 'Valor',
    descricao: 'Pauta',
  };

  function getColunasParaTipo(tipo) {
    if (tipo === 'status_atividade') return ['descricao', 'valor'];
    return ['valor'];
  }

  function getLabelColuna(tipo, col) {
    if (tipo === 'status_atividade') {
      if (col === 'descricao') return 'Pauta';
      if (col === 'valor') return 'Detalhe';
    }
    return 'Valor';
  }

  useEffect(() => { carregarTipos(); }, []);
  useEffect(() => { if (tipoSelecionado) carregarLinhas(tipoSelecionado); }, [tipoSelecionado]);

  async function carregarTipos() {
    const res = await api.get('/parametros/');
    const chaves = [...new Set(res.data.map(p => p.chave))].sort();
    setTipos(chaves);
  }

  async function carregarLinhas(tipo) {
    const res = await api.get(`/parametros/${encodeURIComponent(tipo)}`);
    const dados = res.data
  .map(p => ({ ...p, _status: 'original' }))
  .sort((a, b) => (a.descricao || '').localeCompare(b.descricao || '', 'pt-BR'));
    setLinhas(dados);
    setOriginal(JSON.parse(JSON.stringify(dados)));
    setAlterado(false);
  }

  function trocarTipo(novoTipo) {
    if (alterado) {
      const confirmar = window.confirm('Você tem alterações não salvas. Deseja descartar e trocar de tipo?');
      if (!confirmar) return;
    }
    setTipoSelecionado(novoTipo);
  }

  function editarCelula(index, campo, valor) {
    const novas = [...linhas];
    novas[index] = { ...novas[index], [campo]: valor, _status: novas[index]._status === 'novo' ? 'novo' : 'editado' };
    setLinhas(novas);
    setAlterado(true);
  }

  function adicionarLinha() {
    const nova = { chave: tipoSelecionado, valor: '', descricao: '', ativo: true, _status: 'novo' };
    setLinhas([...linhas, nova]);
    setAlterado(true);
  }

  function toggleAtivo(index) {
    const novas = [...linhas];
    novas[index] = { ...novas[index], ativo: !novas[index].ativo, _status: novas[index]._status === 'novo' ? 'novo' : 'editado' };
    setLinhas(novas);
    setAlterado(true);
  }

  async function salvar() {
    const pautasValidas = ['Em Prospecção', 'Em Andamento', 'Aguardando Registro', 'Aguardando Financeiro', 'Finalizado'];
    if (tipoSelecionado === 'status_atividade') {
      const invalidas = linhas.filter(l => l._status !== 'original' && l.ativo && l.descricao && !pautasValidas.includes(l.descricao));
      if (invalidas.length > 0) {
        alert(`Pauta inválida: "${invalidas[0].descricao}"\n\nValores permitidos:\n${pautasValidas.join('\n')}`);
        return;
      }
    }
    setSalvando(true);
    try {
      for (const linha of linhas) {
        if (linha._status === 'novo' && linha.valor.trim()) {
          await api.post('/parametros/', { chave: linha.chave, valor: linha.valor, descricao: linha.descricao });
        } else if (linha._status === 'editado' && linha.id) {
          if (!linha.ativo) {
            await api.delete(`/parametros/${linha.id}`);
          } else {
            await api.put(`/parametros/${linha.id}`, { chave: linha.chave, valor: linha.valor, descricao: linha.descricao });
          }
        }
      }
      await carregarLinhas(tipoSelecionado);
      await carregarTipos();
    } finally {
      setSalvando(false);
    }
  }

  function descartar() {
    setLinhas(JSON.parse(JSON.stringify(original)));
    setAlterado(false);
  }

  function labelTipo(tipo) {
    const labels = {
      'status_atividade': 'Status de Atividade',
      'tema_documento': 'Temas de Documento',
      'coluna_Em Prospecção': 'Colunas — Em Prospecção',
      'coluna_Em Andamento': 'Colunas — Em Andamento',
      'coluna_Aguardando Registro': 'Colunas — Aguardando Registro',
      'coluna_Aguardando Financeiro': 'Colunas — Aguardando Financeiro',
      'coluna_Finalizado': 'Colunas — Finalizado',
      'coluna_Consultar': 'Colunas — Consultar',
    };
    return labels[tipo] || tipo;
  }

  function corTexto(linha) {
    if (linha._status === 'editado' || linha._status === 'novo') return '#e53935';
    if (!linha.ativo) return '#aaa';
    return '#1a1a2e';
  }

  function corFundo(linha, i) {
    if (!linha.ativo) return '#f5f5f5';
    if (i % 2 === 0) return '#f9fbff';
    return '#fff';
  }

  const colunas = getColunasParaTipo(tipoSelecionado);

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Parâmetros</h1>
          {alterado && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button style={styles.botaoSalvar} onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : '💾 Salvar alterações'}
              </button>
              <button style={styles.botaoDescartar} onClick={descartar}>✕ Descartar</button>
            </div>
          )}
        </div>

        <div style={styles.filtroBar}>
          <label style={styles.filtroLabel}>Tipo de parâmetro:</label>
          <select style={styles.filtroSelect} value={tipoSelecionado} onChange={e => trocarTipo(e.target.value)}>
            {tipos.map(t => <option key={t} value={t}>{labelTipo(t)}</option>)}
          </select>
          {alterado && <span style={styles.alertaAlterado}>⚠️ Alterações pendentes</span>}
        </div>

        <div style={styles.excelContainer}>
          <div style={styles.excelHeader}>
            <div style={{ ...styles.excelCellHeader, minWidth: '40px', flex: 'none', width: '40px' }}>#</div>
            {colunas.map(col => (
              <div key={col} style={{ ...styles.excelCellHeader, flex: 1 }}>
                {getLabelColuna(tipoSelecionado, col)}
              </div>
            ))}
            <div style={{ ...styles.excelCellHeader, minWidth: '60px', flex: 'none', width: '60px', textAlign: 'center' }}>Ativo</div>
          </div>

          {linhas.map((linha, i) => (
            <div key={i} style={{ ...styles.excelRow, backgroundColor: corFundo(linha, i) }}>
              <div style={{ ...styles.excelCell, minWidth: '40px', flex: 'none', width: '40px', color: '#999', fontSize: '11px' }}>{i + 1}</div>
              {colunas.map(col => (
                <div key={col} style={{ ...styles.excelCellInput, flex: 1 }}>
                  <input
                    style={{ ...styles.inputExcel, color: corTexto(linha), textDecoration: !linha.ativo ? 'line-through' : 'none' }}
                    value={linha[col] || ''}
                    onChange={e => editarCelula(i, col, e.target.value)}
                    disabled={!linha.ativo}
                  />
                </div>
              ))}
              <div style={{ ...styles.excelCell, minWidth: '60px', flex: 'none', width: '60px', justifyContent: 'center' }}>
                <input
                  type="checkbox"
                  checked={linha.ativo}
                  onChange={() => toggleAtivo(i)}
                  style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                />
              </div>
            </div>
          ))}

          <div style={styles.excelAddRow} onClick={adicionarLinha}>
            <span style={styles.excelAddText}>+ Adicionar linha</span>
          </div>
        </div>

        <div style={styles.legenda}>
          <span style={styles.legendaItem}><span style={{ color: '#e53935', fontWeight: 'bold' }}>A</span> Alteração pendente</span>
          <span style={styles.legendaItem}><span style={{ color: '#aaa', textDecoration: 'line-through' }}>A</span> Inativo</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  botaoSalvar: { backgroundColor: '#217346', color: '#fff', border: 'none', padding: '9px 18px', borderRadius: '4px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' },
  botaoDescartar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '9px 18px', borderRadius: '4px', fontSize: '13px', cursor: 'pointer' },
  filtroBar: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1rem', backgroundColor: '#fff', padding: '12px 16px', borderRadius: '6px', border: '1px solid #e0e0e0' },
  filtroLabel: { fontSize: '13px', color: '#555', fontWeight: '500' },
  filtroSelect: { padding: '7px 12px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', minWidth: '250px' },
  alertaAlterado: { fontSize: '12px', color: '#f57c00', fontWeight: '500' },
  excelContainer: { backgroundColor: '#fff', border: '2px solid #217346', borderRadius: '4px', overflow: 'hidden' },
  excelHeader: { display: 'flex', backgroundColor: '#217346', color: '#fff' },
  excelCellHeader: { flex: 1, padding: '8px 12px', fontSize: '12px', fontWeight: '600', letterSpacing: '0.5px', borderRight: '1px solid rgba(255,255,255,0.2)' },
  excelRow: { display: 'flex', borderBottom: '1px solid #e8e8e8' },
  excelCell: { flex: 1, padding: '6px 12px', fontSize: '13px', display: 'flex', alignItems: 'center', borderRight: '1px solid #e8e8e8' },
  excelCellInput: { flex: 1, borderRight: '1px solid #e8e8e8', display: 'flex', alignItems: 'center' },
  inputExcel: { width: '100%', border: 'none', outline: 'none', padding: '7px 12px', fontSize: '13px', backgroundColor: 'transparent' },
  excelAddRow: { display: 'flex', padding: '8px 12px', cursor: 'pointer', borderTop: '1px solid #e8e8e8', backgroundColor: '#f9fbff' },
  excelAddText: { fontSize: '13px', color: '#217346', fontWeight: '500' },
  legenda: { display: 'flex', gap: '20px', marginTop: '0.75rem', padding: '0 4px' },
  legendaItem: { fontSize: '11px', color: '#888', display: 'flex', alignItems: 'center', gap: '6px' },
};